import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./Footer.module.scss";

const Footer: FC = () => {
  const { theme } = useTheme();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p
          className={`${styles.curatedBy} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
        >
          Curated by Analysts at Alphamind
        </p>
      </div>
    </div>
  );
};

export default Footer;
